import React, { Component } from 'react'
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg'
import CommonGridHeader, { CommonPatientCard, CommonPatientDetails, DeletePopup, ToolsField, ToolsFieldWithMic, ReasonPopup } from '../../../../../Components/Common Components/CommonComponents'
import { Colors } from '../../../../../Styles/Colors'
import { Autocomplete, Box, Button, CircularProgress, Dialog, Divider, IconButton, Menu, MenuItem, Modal, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { ImagePaths } from '../../../../../Utility/ImagePaths'
import { getCachevalue, localGetItem } from '../../../../../Utility/Services/CacheProviderService'
import RestAPIService from '../../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../../Utility/API/Serviceurls'
import { CheckAccessFunc, fetchAndConvertToBase64 } from '../../../../../Components/CommonFunctions/CommonFunctions'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PrintPreviewPop from '../../../../../Components/Common Components/PrintPreviewPop'
import { Bucket_Name } from '../../../../../Utility/Constants'
import { DateTime } from 'luxon';
import DescriptionIcon from '@mui/icons-material/Description';
import DocumentPreviewPop from '../../../../../Components/Common Components/DocumentPreviewPop'

let isUser = null;
let AWS = require('aws-sdk');
let s3 = new AWS.S3({
  signatureVersion: 'v4',
  region: "ap-south-1",
  params: { Bucket: Bucket_Name },
});

export default class RadTestReports extends Component {
  constructor(props) {
    super(props)
    this.state = {
      patientData: {},
      attender_mobile: '',
      attender_name: '',
      page: 0,
      pageSize: 10,
      testReportData: [],
      testServiceData: [],
      ResultTextData: "",
      EditorDisable : false,
      editedText: '',
      confirmpopup: false,
      ResultPDF: [],
      printPreviewPop: false,
      printPreviewData: [],
      pdfName: '',
      showNewBill:false,
      printImgData: [],
      selectedID:null,
      isInfoMsg: false,
      isInfoMsgText: '',
      deletedList: [],
      isSave: false,
      leftSign: null,
      rightSign: null,
      radHistoryPopup: false,
      patientHistory:[],
      loading: false,
      s3Loading: false,
    }
    this.editorRef = React.createRef();
  }
  

  componentDidMount() {
    let showNewBill = localGetItem('isNewBilling')
    this.setState({showNewBill:JSON.parse(showNewBill)},() => {
      isUser = JSON.parse(localGetItem('loggedInUserInfo'))      
      let patientData = JSON.parse(getCachevalue('RadPatientData'))
      let checkpaymentstatus = localGetItem('op_test_report_payment_check') === 'true' ? true : false;
      this.setState({
        patientData: patientData,
        checkpaymentstatus: checkpaymentstatus
      }, () => this.getPatientTestReportData())
    })
    if(localGetItem("isNewBilling") === 'true' && !localGetItem('is_investigation_module')){
      this.getRedEsign()
    }
  }

  getRedEsign = () => {
    try {
      RestAPIService.getAll(Serviceurls.RAD_ESIGN_GET).
        then((response) => {
          if (response.data.status === "success") {
            let data = response.data.data?.filter((item) => item.status)
            this.setState({ EsignatureList: data }
            )
          }
        }).catch((e) => {
          this.errorMessage(e?.response?.data?.message || e?.message)
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  getPatientTestReportData = () => {        
    try {
      let params = ''
      if (this.state.patientData?.ip_admission_id) {
        params = `?admission_id=${this.state.patientData?.ip_admission_id}`
      } else if (this.state.patientData?.appointment_id) {
        params = `?appointment_id=${this.state.patientData?.appointment_id}`
      }
      else {
        let date = this.state.patientData?.invoice_date
          ? this.state.patientData.invoice_date.slice(0, 10).split('-')
          : [];

        let invoiceDate = date.length === 3
          ? `${date[2]}-${date[1]}-${date[0]}`
          : null;

        params = `?patient_id=${this.state.patientData?.patient_id}&bill_date=${invoiceDate}`
      }
      this.setState({ isLoader: true })
      let api = this.state.showNewBill ? (localGetItem('is_investigation_module') === "true" ? Serviceurls.NEW_INVESTIGATION_PATIENT_BILLS_GET : Serviceurls.NEW_RAD_PATIENT_BILLS_GET) : Serviceurls.RAD_PATIENT_BILLS_GET
      RestAPIService.getAll(api + params)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              testReportData: response.data.data,
              isLoader: false
            }, () => {
              let testServiceData = []
              this.state.testReportData?.forEach(element => {
                element?.service_details?.forEach((secElement) => {
                  secElement = { ...secElement, bill_summary_id: element.bill_summary_id, payment_status: (this.state.showNewBill && localGetItem('is_investigation_module') !== "true") ? secElement.payment_status : element.payment_status }
                  testServiceData?.push(secElement)
                })
              })
              this.setState({ testServiceData: testServiceData })
            })
          }
        }).catch((error) => {
          this.setState({ isLoader: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ isLoader: false })
      this.errorMessage(error.message)
    }
  }
  getRadPateintHistoryData = () => {
    try {
      const radiologyId = JSON.parse(localGetItem('loggedInUserInfo'))?.radiology_id;
      const clinicId = JSON.parse(localGetItem('loggedInUserInfo'))?.clinic_id
      RestAPIService.getAll(Serviceurls.RAD_PATIENT_BILLS_HISTORY +`?patient_id=${this.state.patientData?.patient_id}`+ `&radiology_id=${radiologyId}`+`&clinic_id=${clinicId}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              patientHistory: response.data.data,
              loading: false
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
getPatientHistoryPrint = (id) => {
  try {
    let api = localGetItem("isNewBilling") === "true"? Serviceurls.NEW_RAD_RESULT_PRINT : Serviceurls.RAD_RESULT_PRINT
    RestAPIService.getAllPrint(`${api}?id=${id}&export_type=pdf`)
       .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if(error?.response?.data?.message==="'NoneType' object has no attribute 'split'" || error?.response?.data?.message==="'NoneType' object has no attribute 'replace'"){
            this.errorMessage("No data found", false);
          }else{
             this.errorMessage(error.response?.data?.message, false);
          }
        })

  } catch (error) {
    this.errorMessage(error.message || "Unexpected error");
  }
};


  getResultTemplateData = () => {
    try {
      this.setState({ tempPost: true })
      RestAPIService.getAll((localGetItem('is_investigation_module') === "true" ? Serviceurls.INVESTIGATION_RESULT_GET : Serviceurls.RAD_RESULT_GET) + '?service_type=' + this.state.selectedServiceData?.service_type + '&service_name=' + this.state.selectedServiceData?.service_name)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              templateData: response.data.data ? response.data.data : [],
              // selectedTemplate: this.state.selectedServiceData?.template_name ? this.state.selectedServiceData?.template_name : response.data.data[0],
              // selectedTemplateResult: this.state.selectedServiceData?.result_data ? this.state.selectedServiceData?.result_data : response.data.data[0]?.template_data
            }, () => {
              this.setState({
                ResultTextData: this.state.selectedServiceData?.result_data ? this.state.selectedServiceData?.result_data : ""
              })
              // this.editorRef.current.innerHTML = this.state.selectedServiceData?.result_data ? this.state.selectedServiceData?.result_data : response.data.data[0]?.template_data ? response.data.data[0]?.template_data : ""
            })
          }
        }).catch((error) => {
          this.setState({ tempPost: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ tempPost: false })
      this.errorMessage(error.message)
    }
  }

  postResultTemplateData = (ResultData, isForSave = false, isForCompleted = false, file) => {
    try {
      this.setState({isSave: true});
      const startDate = new Date()
      const date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      const time = DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
      const date_time = `${date} ${time}`
      const data = new FormData();
      data.append('id', this.state.selectedServiceData?.id)
      data.append('result_data', ResultData ? ResultData : this.state.editedText ? this.state.editedText : "")
      data.append('update_status', isForSave ? 'Result Saved' : isForCompleted ? 'Completed' : "Dispatched")
      data.append('template_name', this.state.selectedTemplate?.template_name ? this.state.selectedTemplate?.template_name : this.state.selectedTemplate || '')
      data.append('deleted_list', JSON.stringify([...new Set(this.state.deletedList)] || []))
      data.append('date_time', date_time)
      data.append('esign_left', typeof(this.state.leftSign) === 'object' ? (this.state.leftSign?.id || '') : (this.state.leftSign || ''))
      data.append('esign_right', typeof(this.state.rightSign) === 'object' ? (this.state.rightSign?.id || '') : (this.state.rightSign || ''))
      if (file?.length > 0) {
        for (let i = 0; i < file.length; i++) {
          if (file[i]?.document_file instanceof Blob || file[i]?.document_file instanceof File) {
            data.append('result_document', file[i]?.document_file, file[i].document_name);
          }
        }
      } else if (this.state.ResultPDF?.length > 0 && file?.length === 0) {
        data.append('result_document', "")
        data.append('is_deleted', true)
      } else {
        data.append('result_document', "")
      }
      RestAPIService.create(data, this.state.showNewBill ? (localGetItem('is_investigation_module') === "true" ? Serviceurls.INVESTIGATION_RESULT_GET_NEW : Serviceurls.RAD_RESULT_GET_NEW) :  Serviceurls.RAD_RESULT_GET)
        .then((response) => {
          if (response.data.status === 'success') {
            this.successMessage(response.data.message)
            this.getPatientTestReportData()
            this.setState({
              selectedServiceData: null,
              selectedTemplate: null,
              selectedTemplateResult: '',
              templatePopUpOpen: false,
              tempPost: false,
              isSave: false,
              EditorDisable: false,
              ResultTextData: "",
              confirmpopup: false,
              editedText: '',
              deletedList: [],
              leftSign: null,
              rightSign: null,
            })
          }
        }).catch((error) => {
          this.setState({ isSave: false })
          this.errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      this.setState({ isSave: false })
      this.errorMessage(error.message)
    }
  }

  async getS3Key(documents) {
    try {
      if (!documents || documents.length === 0) return;

      let previewItems = [];

      for (const doc of documents) {
        const docName = doc.document_name;
        const docKey = doc.document_file;

        const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(docKey));

        if (response.data.status === "success") {
          const fileUrl = response?.data?.data;
          if (docName.toLowerCase().includes("jpg")) {
            previewItems.push({ type: "image", url: fileUrl, name: docName });
          } else {
            previewItems.push({ type: "pdf", url: fileUrl, name: docName });
          }
        } else {
          continue;
        }
      }

      this.setState({
        printPreviewPop: true,
        printPreviewData: previewItems,
        pdfName: "Result Preview",
        s3Loading: false
      });

    } catch (e) {
      this.setState({
        isErrorMsg: true,
        isErrorMsgText: "Error fetching S3 URL",
        s3Loading: false
      });
    }
  }


  handleStyleChange = (command) => {
    document.execCommand(command, false, null);
  };

  PopupClose = () => {
    this.setState({
      confirmpopup: false,
      editedText: ''
    })
  }

  dispatchPopup = (value) => {
    this.setState({
      confirmpopup: true,
      editedText: value
    })
  }

  renderResultUploadPopup = () => {
    try {
      return (
          <Dialog open={this.state.templatePopUpOpen} fullWidth={true} maxWidth={'md'} >
            <Box component={'div'}>
              <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} mt={"0.5vw"} mr={'0.5vw'}>
              {(localGetItem("isNewBilling") === 'false' || localGetItem('is_investigation_module') === "true") ? null : <Autocomplete
                value={typeof this.state.leftSign === "number"
                  ? this.state.EsignatureList.find(x => x.id === this.state.leftSign) || null
                  : this.state.leftSign}
                options={this.state.EsignatureList || []}
                disabled={this.state.selectedServiceData?.result_status === 'Completed' ? true : this.state.selectedServiceData?.result_status === 'Dispatched' ? true : false}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : `${option?.role_name} - ${option?.name}`}
                size='small'
                onChange={(e, value) => {
                  this.setState({
                    leftSign: value
                  })
                }}
                sx={{ width: '18vw', ml: '.5vw' }}
                renderInput={(params) => <TextField {...params} label='Select Left E-Sign' />}
              />}
              {(localGetItem("isNewBilling") === 'false' || localGetItem('is_investigation_module') === "true") ? null : <Autocomplete
                value={typeof this.state.rightSign === "number"
                  ? this.state.EsignatureList.find(x => x.id === this.state.rightSign) || null
                  : this.state.rightSign}
                options={this.state.EsignatureList || []}
                disabled={this.state.selectedServiceData?.result_status === 'Completed' ? true : this.state.selectedServiceData?.result_status === 'Dispatched' ? true : false}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : `${option?.role_name} - ${option?.name}`}
                size='small'
                onChange={(e, value) => {
                  this.setState({
                    rightSign: value
                  })
                }}
                sx={{ width: '18vw', ml: '.5vw', mr: '.5vw' }}
                renderInput={(params) => <TextField {...params} label='Select Right E-Sign' />}
              />}
                <Autocomplete
                  value={this.state.selectedTemplate ? this.state.selectedTemplate : null}
                  options={this.state.templateData ? this.state.templateData : []}
                  disabled={this.state.selectedServiceData?.result_status === 'Completed' ? true : this.state.selectedServiceData?.result_status === 'Dispatched' ? true : false}
                  getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.template_name}
                  size='small'
                  onChange={(e, value) => {
                    this.setState({
                      selectedTemplate: value
                    }, () => {
                      if (this.state.selectedTemplate !== null) {
                        this.setState({
                          ResultTextData: this.state.selectedTemplate?.template_data
                        })
                      } else {
                        this.setState({
                          ResultTextData: ""
                        })
                      }
                    })
                  }}
                  sx={{ width: '20vw', mr: '2vw' }}
                  renderInput={(params) => <TextField {...params} label='Select Template' />}
                />
                <Button className='Common_Btn_Min_Width' emed_tid='rad_tmp_cls_btn'
                  onClick={() => this.setState({
                    templatePopUpOpen: false,
                    selectedServiceData: null,
                    selectedTemplateResult: '',
                    ResultTextData: '',
                    EditorDisable: false,
                    selectedTemplate: null,
                    deletedList: [],
                    leftSign: null,
                    rightSign: null,
                  })}
                >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                </Button>
              </Box>
              <ToolsFieldWithMic
                FromTestReport={true}
                selectedServiceData={this.state.selectedServiceData}
                EditorDisable={this.state.EditorDisable}
                isDispatchshown={this.state.isDispatchshown}
                Title={"Result"}
                EditorRef={this.state.ResultTextData}
                handleSaveResult={this.postResultTemplateData.bind(this)}
                handlePostResult={this.postResultTemplateData.bind(this)}
                handleDispatchResult={this.dispatchPopup.bind(this)} 
                overallHeight={"70vh"} 
                EditorHeight={"53vh"}
                ResultPDF={this.state.ResultPDF}
                micTextEditDisabled={true}
                addSpaceOnTab = {true}
                errorMsg={this.errorMessage.bind(this)}
                deletedLineItem={(list) => {
                  this.setState((prevState) => ({deletedList:[...prevState.deletedList, list]}))}}
                isSaved={this.state.isSave}
              />
            </Box>
        </Dialog>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: '',
      isInfoMsg: false,
      isInfoMsgText: '',
    })
  }

  PrintReport = (id, list) => {
    try {
      if (this.state.checkpaymentstatus && (list?.payment_status?.toLowerCase() === "not paid" || list?.payment_status?.toLowerCase() === "partial") && !this.state.patientData?.ip_admission_id) {
        this.setState({
          isInfoMsg: true,
          isInfoMsgText: "Payment is not completed. For printing the report, please complete the payment.",
          isPrintClicked: false,
        })
      }
      else {
        RestAPIService.getAll((localGetItem("isNewBilling") === "true" ? (localGetItem('is_investigation_module') === "true" ? Serviceurls.NEW_INVESTIGATION_RESULT_PRINT : Serviceurls.NEW_RAD_RESULT_PRINT) : Serviceurls.RAD_RESULT_PRINT) + '?id=' + id + "&export_type=pdf" + '&check_payment_status=true').
          then((response) => {
            if( response.status == 204){
              this.setState({
                isInfoMsg: true,
                isInfoMsgText: "Payment is not completed. For printing the report, please complete the payment.",
              })
            }else{
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            }
            this.setState({
              selectedOption: ""
            })
          }).catch((error) => {
            this.errorMessage(error.response?.data?.message, false);
          })
      }
    } catch (error) {
      this.errorMessage(error.message, false)
    }
  }

  printBarCode = (bill_id, line_id) => {
    try {
      RestAPIService.getAllPrint((localGetItem("isNewBilling") === "true" ? (localGetItem('is_investigation_module') === "true" ? Serviceurls.NEW_INVESTIGATION_BARCODE_PRINT : Serviceurls.NEW_RAD_BARCODE_PRINT) : Serviceurls.RAD_BARCODE_PRINT) + '?patient_id=' + this.state.patientData?.patient_id + "&radiology_bill_summary_id=" + bill_id + "&id=" + line_id)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({
            anchorEl: null,
            selectedRow: null,
            isSelected: false
          })
        }).catch((error) => {
          this.errorMessage(error.response?.data?.message, false);
        })
    } catch (error) {
      this.errorMessage(error.message, false)
    }
  }


    reasonPopupClose = () => {
        this.setState({
            selectedOption: ""
        })
    }


  revertRadiologyResult = (comments) => {
    try {
      let states = this.state
      let patientData = states.patientData;
      let data = {}

      if (patientData.module === 'IP') {
        data = {

          'ip_admission_id': patientData?.ip_admission_id,
          'radiology_result_id': states.selectedID,
          'patient_id': patientData?.patient_id,
          'remarks': comments,
        };
      } else if (patientData.module === 'OP') {
        data = {
          'appointment_id': patientData?.appointment_id,
          'radiology_result_id': states.selectedID,
          'patient_id': patientData?.patient_id,
          'remarks': comments
        };

      } else if (patientData.module === 'RADIOLOGY') {
        data = {
          'radiology_result_id': states.selectedID,
          'patient_id': patientData?.patient_id,
          'remarks': comments
        };

      } else {
        this.setState({
          isErrorMsg: true,
          isErrorMsgText: "Invalid or missing module type specified.",
          selectedOption: "",
        });
        if (this.setIsLoading) this.setIsLoading(false);
        return;
      }

      RestAPIService.create(data, Serviceurls.REVERT_RADIOLOGY_URL)
        .then((response) => {
          if (response.data.status == 'success') {
            this.setState({
              successMsg: true,
              successMsgText:response.data.message,
              selectedOption: "",
            })
            if(!isUser?.is_user){
              this.getPatientTestReportData()
            }
          }
        }).catch((e) => {
          if (e.response.data.status === "fail") {
            this.setState({
              isErrorMsg: true,
              isErrorMsgText:e?.response?.data?.message,
              selectedOption: "",
            })
          } else {
            this.setState({
              isErrorMsg: true,
              isErrorMsgText:e.message,
              selectedOption: "",
            })
          }
        })
    } catch (e) {
      this.setState({
        isErrorMsg: true,
        isErrorMsgText:e.message,
        selectedOption: "",
      })
    }
  }


  moreActionOption = (data) => {
    const validStatuses = new Set(["In Progress", "Result Saved"]);
    const multi_option = [
      { label: "View Document", value: "viewDocument" },
    ];
    if (validStatuses.has(data?.row?.result_status)) {
      multi_option.push({ label: "Print Bar code", value: "printBarCode" });
    }
    if(data?.row?.result_status === "Completed" && localGetItem('isNewBilling') === "true" && localGetItem('is_investigation_module') !== "true") {
      multi_option.push({ label: "Revert Test", value: "revertRadiologyResult" });
    }
    return (
      <div>
        <Tooltip title={"More"} placement='top' arrow>
          <IconButton
            onClick={(e) => {
              this.setState({
                anchorEl: e.currentTarget,
                selectedRow: data.id,
                isSelected: true
              })
            }}
          > 
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
        {(this.state.isSelected && this.state.selectedRow == data.id) ?
          <Menu
            anchorEl={this.state.anchorEl}
            open={Boolean(this.state.anchorEl)}
            onClose={() => {
              this.setState({ anchorEl: null })
            }}
          >
            {multi_option.map((option) => (
              <MenuItem key={option}
                disabled={option.value === "viewDocument" ? !(data?.row?.result_document?.length > 0) || this.state.s3Loading : false}
                onClick={() => {
                  if (option.value === "viewDocument") {
                    this.setState({ s3Loading: true });
                    this.getS3Key(data?.row?.result_document)
                  } else if (option.value === "printBarCode") {
                    this.printBarCode(data?.row?.bill_summary_id, data?.row?.id)
                  } else if (option.value === "revertRadiologyResult") {
                    this.setState({
                      selectedOption: "Revert",
                      selectedID: data?.row?.id
                    })
                  }
                }}>
                {option.label}
                {option.value === "viewDocument" && this.state.s3Loading && (
                  <CircularProgress size={16} sx={{ ml: 1, color: '#04B7B1' }} />
                )}
              </MenuItem>
            ))}
          </Menu> : null}
      </div>
    )
  }

  closePrintPreview = () => {
    this.setState({
      printPreviewPop: false,
      printPreviewData: [],
      pdfName: ''
    })
  }
  getAllDocuments = (details) => {
    if (!details || details.length === 0) return [];

    let docs = [];

    details.forEach((d) => {
      if (d.result_document && Array.isArray(d.result_document)) {
        docs.push(...d.result_document); 
      }
    });

    return docs;
  };
  hasDocuments = (details) => {
    if (!details || details.length === 0) return false;

    for (const d of details) {
      if (Array.isArray(d.result_document) && d.result_document.length > 0) {
        return true;
      }
    }
    return false;
  };


  render() {
    let data = {
      lineOne: "Attender Name",
      lineTwo: `${this.state.attender_name ? this.state.attender_name : "-"}`,
      lineFour: "Contact Number",
      LineFive: `${this.state.attender_mobile ? this.state.attender_mobile : "-"}`
    }
    const columns = [
      { field: 'sno', headerName: 'S.no', flex: 0.1 },
      {
        field: 'service_type', headerName: 'Service Type', flex: 0.25,
        renderCell: (params) => (<Box>{params?.row?.service_type ? params?.row?.service_type : '-'}</Box>)
      },
      {
        field: 'service_name', headerName: 'Service Name', flex: 0.25,
        renderCell: (params) => (<Box>{params?.row?.service_name ? params?.row?.service_name : '-'}</Box>)
      },
      {
        field: 'result_status', headerName: 'Result Status', flex: 0.2,
        renderCell: (params) => (<Box>{params?.row?.result_status ? params?.row?.result_status : '-'}</Box>)
      },
      ...((localGetItem('isNewBilling') === 'true' && localGetItem('is_investigation_module') !== "true") ?
        [{
          field: 'payment_status', headerName: 'Payment Status', flex: 0.1, headerAlign: "center", align: "center",
          renderCell: (params) => (<Box sx={{ textTransform : 'capitalize'}}>{params?.row?.payment_status ? params?.row?.payment_status : 'Not Paid'}</Box>)
        }] : []),
      {
        field: 'action', headerName: 'Action', flex: 0.2, headerAlign: "center", align: "center",
        renderCell: (params) => (
          <Box component={'div'} display={'flex'} alignItems={'center'}>
            {params?.row?.result_status === "In Progress" || params?.row?.result_status === "Result Saved" ?
              <Button className='Common_Btn_Min_Width' sx={{ height: '1.5vw' }} emed_tid='rad_bill_upl'
                disabled={!CheckAccessFunc('Radiology', "Home", 'Reports', 'Test Reports', "SubTab")?.editAccess}
                onClick={() => this.setState({ templatePopUpOpen: true, selectedServiceData: params?.row, ResultPDF: params?.row?.result_document ? params?.row?.result_document : [], leftSign: params?.row?.esign_left_id,  rightSign: params?.row?.esign_right_id,}, () => this.getResultTemplateData())}>
                <Box component={'img'} src={ImagePaths.UploadBtnTheme.default} height={'1.5vw'} width={'1.5vw'} />
              </Button> :
              <Button className='Common_Btn_Min_Width' sx={{ height: '1.5vw' }} emed_tid='rad_bill_view'
                onClick={() => this.setState({
                  selectedTemplate: params?.row?.template_name,
                  selectedTemplateResult: params?.row?.template_data,
                  selectedServiceData: params?.row,
                  ResultTextData: params?.row?.result_data ? params?.row?.result_data : "",
                  ResultPDF: params?.row?.result_document ? params?.row?.result_document : [],
                  leftSign: params?.row?.esign_left_id,
                  rightSign: params?.row?.esign_right_id,
                }, () => {
                  this.setState({ templatePopUpOpen: true, EditorDisable: true, isDispatchshown: params?.row?.result_status === "Dispatched" ? false : true })
                })}
                disabled={!CheckAccessFunc('Radiology', "Home", 'Reports', 'Test Reports', "SubTab")?.editAccess}>
                <Box component={'img'} src={ImagePaths.LabViewButton.default} height={'1.5vw'} width={'1.5vw'} />
              </Button>}
            {params?.row?.result_status === "Result Saved" || params?.row?.result_status === "Completed" || params?.row?.result_status === "Dispatched" ?
              <Button className='Common_Btn_Min_Width' onClick={() => { this.PrintReport(params?.row?.id, params?.row) }} >
                <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'1.5vw'} width={'1.5vw'} />
              </Button> :
              <Button className='Common_Btn_Min_Width'>
                <Box component={'img'} src={ImagePaths.LabPrintIconOff.default} height={'1.5vw'} width={'1.5vw'} />
              </Button>}
            {this.moreActionOption(params)}
          </Box>
        )
      }]
    this.state.testServiceData?.forEach((element, index) => element.sno = index + 1)
    return (
      <Box component={'div'}>
        <Box component={'div'} sx={{ backgroundColor: Colors.Background, height: '73vh' }}>
          <Box component={'div'} height={"9.5vh"}>
            <Box component={'div'} display={'flex'} justifyContent={'space-between'}>
              <Box component={'div'} className='eMed_nur_notes_details' ml={'0.5vw'}>
                <CommonPatientDetails data={this.state.patientData} showDetailed={(this.state.patientData?.op_number || this.state.patientData?.ip_number) ? true : false} />
              </Box>
              <Button
                className='Common_Btn_Min_Width'
                sx={{ height: "2vw", width: '2vw', mr: '1vw',top:'2vw' }}
                onClick={() => this.setState({ radHistoryPopup: true,}, () => this.getRadPateintHistoryData())}
              >
                <Box component={'img'} src={ImagePaths.ResultHistory.default} height={'2vw'} width={'2vw'} />
              </Button>
            </Box>
          </Box>
          <Box component={'div'} m={'0.5vw'} height={'61vh'} sx={{ backgroundColor: Colors.white }}>
            <DataGrid
              columns={columns}
              rows={this.state.testServiceData}
              getRowId={(row) => row['sno']}
              page={this.state.page}
              pageSize={this.state.pageSize}
              hideFooterSelectedRowCount
              localeText={{
                toolbarColumns: "",
                toolbarDensity: "",
                toolbarExport: "",
                toolbarFilters: "",
                toolbarExportPrint: ""
              }}
              headerHeight={40}
              components={{
                Toolbar: CommonGridHeader.CommonToolBar,
                NoRowsOverlay: () => (
                  <Box className='eMed_conf_nodata'>
                    {'No Records To Be Shown'}
                  </Box>
                )
              }}
              rowsPerPageOptions={[10, 20, 30]}
              disableSelectionOnClick
              pagination
              onPageChange={(newPage) => { this.setState({ page: newPage }) }}
              onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
              loading={this.state.isLoader}
            />
          </Box>
        </Box>
        {this.renderResultUploadPopup()}
        
        <Box component={'div'}>
          <Modal open={this.state.radHistoryPopup}>
            <Box
              component={'div'}
              sx={{
                position: 'absolute',
                top: '55%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: "60vw",
                height: "58.6vh",
                backgroundColor: "white",
                borderRadius: "8px",
                paddingBottom: "0.5vw"
              }}
            >
              <Box
                height="7vh"
                pl="1vw"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontSize="0.9vw" fontWeight={600}>History</Typography>
                <Button onClick={() => this.setState({ radHistoryPopup: false, patientHistory: [] })}>
                  <Box component="img" src={ImagePaths.LabCloseButton.default} height="1vw" width="1vw" />
                </Button>
              </Box>
                <Divider />

              <Box p="0.5vw">
                <Box margin="0.5vw" border="1px solid lightgray">
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ textAlign: "left !important", fontSize: "0.9vw", fontWeight: 600 }}>S.no</TableCell>
                        <TableCell sx={{ textAlign: "left !important", fontSize: "0.9vw", fontWeight: 600, }}>Date & time</TableCell>
                        <TableCell sx={{ textAlign: "left !important", fontSize: "0.9vw", fontWeight: 600 }}>Service</TableCell>
                        <TableCell sx={{ textAlign: "center !important", fontSize: "0.9vw", fontWeight: 600,}}>Result</TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                  <Box sx={{ maxHeight: "44vh", overflowY: "auto" }}>
                    <Table size="small">
                      <TableBody>
                        {this.state.patientHistory?.length > 0 ? (
                          this.state.patientHistory.map((item, index) => {
                            const serviceName = `${item?.service_type} - ${item?.service_name}`;
                            return (
                              <TableRow key={index}>
                                <TableCell sx={{ textAlign: "left" }}>{index + 1}</TableCell>
                                <TableCell sx={{ textAlign: "center" }}>{item?.report_date}</TableCell>

                                <TableCell sx={{ textAlign: "center" }}>
                                  {serviceName.length > 25 ? (
                                    <Tooltip title={serviceName}>
                                      <div>{serviceName.slice(0, 25) + "..."}</div>
                                    </Tooltip>
                                  ) : (
                                    serviceName
                                  )}
                                </TableCell>

                                <TableCell sx={{ textAlign: "center !important" }}>
                                  <Tooltip title="Print">
                                    <Button
                                      sx={{
                                        "&.Mui-disabled": {
                                          cursor: "not-allowed !important",
                                          pointerEvents: "auto !important",
                                        },
                                      }}
                                      disabled={!(item?.result_status === "Completed" || item?.result_status === "Dispatched")}
                                      onClick={() => this.getPatientHistoryPrint(item?.id)} className='eMed_usrconf_btn'>
                                      <img src={ImagePaths.PrintIcons.default} alt="print" className='eMed_action_img' />
                                    </Button>
                                  </Tooltip>
                            <Tooltip title={"Preview"} placement="top" arrow>
                              <Button sx={{
                                bgcolor: '#04B7B1', '&:hover': {
                                  bgcolor: '#04B7B1',
                                },
                                      "&.Mui-disabled": {
                                        // bgcolor: "#A5A5A5 !important",
                                        cursor: "not-allowed !important",
                                        pointerEvents: "auto !important",
                                      },
                                    }}
                                      disabled={!this.hasDocuments(item?.service_details) || !(item?.result_status === "Completed" || item?.result_status === "Dispatched")}
                                      className='eMed_usrconf_btn'
                                      onClick={
                                        this.hasDocuments(item?.service_details)
                                          ? () => this.getS3Key(this.getAllDocuments(item?.service_details))
                                          : undefined
                                      }
                                    >
                                <DescriptionIcon sx={{width:'1.3vw',height:'1.3vw',color:'white'}} 
                                   />


                                    </Button>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            )
                          })
                        ) : (
                          <TableRow>
                              <TableCell>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    fontSize: "0.9vw",
                                    fontWeight: 500,
                                    color: "#555",
                                  }}
                                >
                                  No Records To Be Shown
                                </Box>
                              </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </Box>
                </Box>
              </Box>
              
            </Box>
          </Modal>
        </Box>
        {this.state.printPreviewPop ?
          <DocumentPreviewPop
            Data={this.state.printPreviewData}
            Title={this.state.pdfName}
            BillData={this.state.selectedRow}
            ClosePopUp={() => { this.closePrintPreview() }}
            history={this.props.history}
          /> : null}
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.isInfoMsg ?
          <ToastMsg
            severity={'info'}
            msg={this.state.isInfoMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.confirmpopup ?
          <DeletePopup DeletTitle={"Are you sure you want to dispatch ?"}
            deleteAlertPopupClose={this.PopupClose.bind(this)}
            removeData={this.postResultTemplateData.bind(this)}
            ButtonText={"Confirm"}
          />
          : null}
        {
          this.state.selectedOption === "Revert" ?
            <ReasonPopup
              title={"Are you sure? Do you want to Revert This "}
              AlertPopupClose={this.reasonPopupClose.bind(this)}
              label={"Enter the Reason"}
              btntext={'Cancel'}
              btnvarient={'outlined'}
              btncolor={'error'}
              btntext1={'Confirm'}
              btnvarient1={'contained'}
              sendCmt={this.revertRadiologyResult.bind(this)}
            /> : null
        }
      </Box>
    )
  }
}
